import { render } from "./DouyinCmt.vue?vue&type=template&id=bc2a45e4&scoped=true"
import script from "./DouyinCmt.vue?vue&type=script&lang=js"
export * from "./DouyinCmt.vue?vue&type=script&lang=js"

import "./DouyinCmt.vue?vue&type=style&index=0&id=bc2a45e4&lang=less&scoped=true"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc2a45e4"]])

export default __exports__